@use "variables" as *;

.listItem {
  position: relative;
  .borderBox {
    position: absolute;
    top: 23px;
    left: 23px;
    bottom: 10px;
    right: 0;
    border-width: 1px;
    border-left-style: solid;
    border-bottom-style: solid;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .partialBorderBox {
    position: absolute;
    top: 0;
    left: -9px;
    height: 24px;
    width: 36px;
    border-width: 1px;
    border-left-style: solid;
    border-bottom-style: solid;
    border-bottom-left-radius: 10px;
  }
  .moreButton {
    width: 20px;
    height: 20px;
    visibility: hidden;
  }
  &:hover .moreButton {
    visibility: visible;
  }
}

.userStack {
  display: flex;
  align-items: center;
}

.avatar {
  border-width: 1px;
  width: 30px !important;
  height: 30px !important;
  cursor: pointer;
}

.username {
  font-size: $fontSize-s;
  font-weight: bold;
  margin-left: $spacing-m;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 50;
}

.date {
  font-size: $fontSize-xs;
  margin-left: $spacing-s;
  white-space: pre-wrap;
  z-index: 50;
  pointer-events: none;
}

.date:first-letter {
  text-transform: uppercase;
}

.body {
  margin-left: $spacing-xxl;
  font-size: $fontSize-s;
  padding-left: $spacing-ml;
  white-space: pre-wrap;
  z-index: 50;
}

.spaceBox {
  width: 30px;
}

.button {
  font-size: $fontSize-s !important;
  text-transform: none !important;
  white-space: pre-wrap !important;
}

.repliesList {
  padding-top: 0 !important;
  margin-top: -8px !important;
  margin-left: 24px !important;
}

.divider {
  margin-top: 12px !important;
}

.buttonsStack {
  display: flex;
  align-items: center;
  margin-bottom: $spacing-s;
}

.moreButtonIcon {
  font-size: $fontSize-ml !important;
}
